function getRandomId() {
    return Math.random().toString(36).slice(2);
}

export const getRandomText = (sizeMax = 4) => {
    const alphabet = ['Personal', 'Insurance', 'Blue', 'Red', 'Blueocean'];

    const outputLength = Math.round(Math.random() * sizeMax) + 1;
    let outputString = '';
    for ( let i = 0 ; i < outputLength ; i++ ) {
        const out = alphabet[Math.round(Math.random() * (alphabet.length - 1))] + ' ';
        if ( out ) {
            outputString += out + ' ';
        }
    }

    console.log('output string:', outputString);
    return outputString;
}

export default getRandomId;
